export default __webpack_public_path__ + "static/media/_소슬러시_ 데일리 컬러 노트 옐로우 (무지).6478afcc.png";